import React from "react";
import { Link } from "react-router-dom";
import { Search, User, X } from "lucide-react";

const linkCls = (active) =>
  `link-underline text-xs uppercase tracking-[0.18em] transition-colors ${active ? "text-[#C49A6C]" : "text-[#EAE3D8] hover:text-white"}`;

export const navTestId = (to) => (to === "/" ? "home" : to.slice(1));

export const NavLinks = ({ items, isActive, className }) => (
  <nav className={className}>
    {items.map((n) => (
      <Link key={n.to} to={n.to} data-testid={`nav-${navTestId(n.to)}`} className={linkCls(isActive(n.to))}>
        {n.label}
      </Link>
    ))}
  </nav>
);

export const SearchOverlay = ({ q, setQ, onSubmit, onClose, placeholder }) => (
  <div className="fixed inset-0 z-[60] bg-[#0B0A08]/95 backdrop-blur-md flex items-start justify-center pt-40 px-6" onClick={onClose}>
    <form onClick={(e) => e.stopPropagation()} onSubmit={onSubmit} className="w-full max-w-2xl">
      <div className="flex items-center border-b border-[#262421] pb-4">
        <Search size={22} className="text-[#8A857D]" strokeWidth={1.4} />
        <input
          autoFocus value={q} onChange={(e) => setQ(e.target.value)} data-testid="search-input" placeholder={placeholder}
          className="serif flex-1 bg-transparent text-2xl md:text-3xl text-[#F2EBE1] px-4 outline-none placeholder:text-[#6E685F]"
        />
        <button type="button" onClick={onClose} data-testid="search-close" className="text-[#8A857D] hover:text-[#F2EBE1]">
          <X size={24} strokeWidth={1.4} />
        </button>
      </div>
    </form>
  </div>
);

export const MobileDrawer = ({ items, user, isAdmin, t, onClose }) => (
  <div className="fixed inset-0 z-[60] lg:hidden">
    <div className="absolute inset-0 bg-black/60" onClick={onClose} />
    <div className="absolute inset-y-0 start-0 w-[82%] max-w-sm bg-[#0F0F0F] border-e border-[#262421] p-8 flex flex-col">
      <div className="flex justify-between items-center mb-12">
        <span className="serif text-xl tracking-[0.2em]">OMR PERFUMER</span>
        <button onClick={onClose} data-testid="mobile-menu-close" className="text-[#8A857D]"><X size={24} strokeWidth={1.4} /></button>
      </div>
      <nav className="flex flex-col gap-6">
        {items.map((n) => (
          <Link key={n.to} to={n.to} onClick={onClose} data-testid={`mobile-nav-${navTestId(n.to)}`} className="serif text-2xl text-[#F2EBE1]">{n.label}</Link>
        ))}
      </nav>
      <div className="mt-10 pt-8 border-t border-[#262421] flex flex-col gap-3">
        <Link
          to={user ? "/account" : "/login"} onClick={onClose} data-testid="mobile-account-link"
          className="flex items-center justify-center gap-2.5 border border-[#C49A6C] text-[#C49A6C] text-xs uppercase tracking-[0.2em] py-3.5 hover:bg-[#C49A6C] hover:text-[#0B0A08] transition-colors"
        >
          <User size={16} strokeWidth={1.5} />
          {user ? t("account") : t("login")}
        </Link>
        {isAdmin && (
          <Link to="/admin" onClick={onClose} data-testid="mobile-admin-link" className="flex items-center justify-center text-xs uppercase tracking-[0.2em] text-[#8A857D] hover:text-[#F2EBE1] py-2 transition-colors">
            {t("admin")}
          </Link>
        )}
      </div>
    </div>
  </div>
);
